import { render, staticRenderFns } from "./shudiRightOne.vue?vue&type=template&id=276f4563"
import script from "./shudiRightOne.vue?vue&type=script&lang=js"
export * from "./shudiRightOne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports